<template>
  <v-container style="height: 100%">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Список выданных ролей:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat>
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table

              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="total"
              :loading="loading"
              :rows-per-page-items="[10,25,50]"
              class="elevation-1  "
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">{{props.item.worker }}</td>

                <td class="justify-center">{{findNameObj('role',props.item.role)}}</td>
                <td class="justify-center">{{findNameObj('dissertationCouncil',props.item.dissertationCouncil)}}</td>
                <td class="justify-center " v-bind="selected">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <Role @addItem="addItem"
                @ended="closedForm"
                @refreshItem="addItem"
                v-bind="selected"
                v-if="opened_form"
      >
      </Role>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить ?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
</template>


<script>
  import Role from "../forms/Role"
  import urls from "../../../../../modules/petition/urls"
  import UserDataMixin from '../../../../../mixins/UserDataMixin'
  import urlsU from "../../../../../modules/petition/urlsU.js"
  import {makeGetRequest,makePostRequest} from "../../../../../helper";

  export default {
    name: "ListRole",
    components: {Role},
    mixins: [UserDataMixin],
    watch: {
      pagination: {
        handler () {
          this.getItems()
        },
        deep: true
      }
    },
    data: function () {
      return {
        total: 0,
        items: [],
        loading: true,
        pagination: {},
        URL_LIST: urls.getUrl('admin|permissions|models|role_worker-list', 'list'),
        URL_DELETE: urls.getUrl('admin|permissions|models|role_worker-detail', 'destroy'),
        selectors:{
          dissertationCouncil:[],
          role:[]
        },
        headers: [
          {
            text: 'Работник',
            align: 'justify-center',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Роль',
            align: 'justify-center',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Совет',
            align: 'justify-center',
            sortable: false,
            value: 'name',
          },

          {
            text: 'Действия', sortable: false, align: 'justify-center',
            // class: 'headline'
          }
        ],

      }
    },
    methods: {
      findNameObj(edit,id){
        let obj = this.selectors[edit].find(item => item.value === id);
        if (obj !== undefined) {
          return obj.text
        }else{
          return ""
        }
      },
      addItem(){
        this.closedForm()
        this.getItems();
      },
      getItems: function () {
        this.loading = true
        let url =  new URL(this.URL_LIST)

        let params = {};

        if(this.pagination.page !== undefined) {
          params.page = this.pagination.page;
          params.page_size = this.pagination.rowsPerPage;
        }
        else{
          params.page = "1";
          params.page_size = "10";
        }

        url.search = new URLSearchParams(params).toString();


        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }) .then(json => {
          this.items = json.results
          this.total = json.count
          this.loading = false
          let users = []

          for(let i in this.items){
            users.push(this.items[i].worker);
          }
          makePostRequest(
            urlsU.getUrl('users|user|fio', 'post'),
            {'uids': users}
          )
            .then(resp => resp.json())
            .then(json => {
              for(let i in json){
                let replaced = json.find((item) => item.value === users[i]);
                this.items[i].worker = replaced.text
              }
            });




        })
      },

      loadSelector(data,url){
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }) .then(json => {
          this.selectors[data] = json
        })
      },
    },

    created() {
      this.getItems();
      let url =  process.env.VUE_APP_API_HOST +"council/admin/diss/selectors/dissertation_council/"
      this.loadSelector("dissertationCouncil",url)

      let role_choices = urls.getUrl('admin|permissions|choices|role_choices', 'get')
      let sys = true
      makeGetRequest(role_choices).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        this.selectors.role= json
      })
      this.$store.commit('mainpage/changeTitle', 'Роли');
    },
  }


</script>
<style scoped>

</style>
